import * as Constants from '../constants';
import lodashGet from 'lodash/get';
import lodashKeyBy from 'lodash/keyBy';

const initialState = {
  loading: false,
  data: {},
  promocode: {},
  address: {},
  productIdIndexMap: {
    medicineProductIdMap: {},
    otcProductIdMap: {},
    customItemMap: {}
  },
  substitutedItems: {},
  deliveryPreferences: {},
  cartAmountBifurcation: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

    case Constants.GET_CART_START:
    case Constants.UPDATE_CART_START:
    case Constants.ADD_TO_CART_START:
    case Constants.GET_CART_V5_START:
      return Object.assign({}, { ...state }, { loading: true, action });
    case Constants.GET_CART_SUCCESS: {
      const { productIdIndexMap, updatedMedicineItems } = getProductMapAndSubstitutionInfo(action.data.data, state.substitutedItems);

      if (Object.keys(state.substitutedItems).length && updatedMedicineItems.length) {
        action.data.data.medicine.items = updatedMedicineItems;
      }
      return {
        ...state,
        ...action.data,
          loading: false,
          action,
          productIdIndexMap
      };
    }
    case Constants.GET_CART_V5_SUCCESS: {
      
      const { productIdIndexMap, updatedMedicineItems } = getProductMapAndSubstitutionInfoV5(action.data.items, state.substitutedItems);

      if (Object.keys(state.substitutedItems).length && updatedMedicineItems.length) {
        action.data.items = updatedMedicineItems;
      }

      action.data.itemsCount = action.data.items ? action.data.items.reduce((acc, obj) => (acc + obj.quantity), 0) : 0;
      return {
        ...state,
        ...action,
        loading: false,
        productIdIndexMap,
        action
      }
    }
    case Constants.GET_CART_FAILURE:
    case Constants.GET_CART_V5_FAILURE:
      return Object.assign({ ...state }, action.data, { loading: false, action });

    case Constants.UPDATE_CART_FAILURE:
    case Constants.UPDATE_CART_SUCCESS:
      return Object.assign({}, { ...state }, { action });

    case Constants.ADD_TO_CART_SUCCESS:
    case Constants.ADD_TO_CART_FAILURE:
      return Object.assign({}, { ...state }, { action });

    case Constants.SET_PROMOCODE_START:
      return { ...state, loading: true, action };

    case Constants.SET_PROMOCODE_SUCCESS:
    case Constants.SET_PROMOCODE_FAILURE:
      return Object.assign({}, { ...state }, { promocode: { ...action.data }, loading: false, action });
    case Constants.RESET_PROMOCODE:
      return {
        ...state,
        data: {
          ...state.data,
          promotionDetails: null,
        },
        promocode: {},
        loading: false
      };
    case Constants.SELECT_ADDRESS_SUCCESS:
      return { ...state, address: { id: action.data.id }, action };

    case Constants.PLACE_REORDER_START:
    case Constants.PLACE_REORDER_SUCCESS:
    case Constants.PLACE_REORDER_FAILURE:
      return Object.assign({}, state, { action });

    case Constants.FETCH_CART_SUBSTITUTIONS_SUCCESS:
      const indexedSubstitutedItems = lodashKeyBy(action.data.data.items || [], 'itemId');
      const { updatedMedicineItems: updatedItems } = getProductMapAndSubstitutionInfo(state.data, indexedSubstitutedItems);

      return {
        ...state,
        substitutedItems: indexedSubstitutedItems,
          data: {
            ...state.data,
            medicine: { items: updatedItems }
          }
      };
    case Constants.GET_DELIVERY_PREFERENCES_FAILURE:
    case Constants.GET_DELIVERY_PREFERENCES_SUCCESS: {
      const deliveryPreferences = action.data;
      deliveryPreferences.shipments.forEach(shipment => {
        if(shipment.deliveryOptions.length === 1) {
          shipment.deliveryOptions[0].selected = true;
        }
        //  else {
        //   shipment.deliveryOptions.forEach((option) => {
        //     option.selected = false;
        //     if(!option.extraCharge) {
        //       option.selected = true
        //     } else {
        //       option.selected = false;
        //     }
        //   })
        // }
      })
      return {
        ...state,
        deliveryPreferences,
      }
    }
    case Constants.GET_CART_AMOUNT_BIFURCATION_FAILURE:
    case Constants.GET_CART_AMOUNT_BIFURCATION_SUCCESS:
      return {
        ...state,
        cartAmountBifurcation: action.data,
      }
    case Constants.CHANGE_SHIPMENT_PREFERENCE: {

      const {shipmentIndex, optionIndex} = action.data;

      state.deliveryPreferences.shipments[shipmentIndex].deliveryOptions.forEach((option, index) => {
        if(index === optionIndex) {
          option.selected = true;
        } else {
          option.selected = false;
        }
      })

      return {
        ...state,
      }
    }
    default:
      return { ...state };
  }
}

/**
 * Updates substitution info and returns updated productIdMap
 */
function getProductMapAndSubstitutionInfo(cartData, substitutedItems = {}) {
  const medicineProductIdMap = {};
  const otcProductIdMap = {};
  const customItemMap = {};

  const cartMedItems = lodashGet(cartData, 'medicine.items', []);

  cartMedItems.forEach((item, index) => {
    let itemSubstitutionInfo = substitutedItems[item.itemId];
    if (itemSubstitutionInfo) {
      item.substitutionInfo = itemSubstitutionInfo;
    }
    if (item.isCustom) {
      customItemMap[item.name.toUpperCase()] = index;
    } else {
      medicineProductIdMap[item.productId] = index;
      // Will fail if both original and substitutes items are in cart
      if (itemSubstitutionInfo) {
        medicineProductIdMap[itemSubstitutionInfo.originalProductDetails.id] = index;
      }
    }
  });

  lodashGet(cartData, 'healthcare.items', []).forEach(({ productId }, index) => {
    otcProductIdMap[productId] = index;
  });

  return {
    productIdIndexMap: {
      medicineProductIdMap,
      otcProductIdMap,
      customItemMap,
    },
    updatedMedicineItems: cartMedItems,
  };
}

function getProductMapAndSubstitutionInfoV5(items = [], substitutedItems = {}) {
  const medicineProductIdMap = {};
  const otcProductIdMap = {};
  const customItemMap = {};

  items.forEach((item, index) => {
    let itemSubstitutionInfo = substitutedItems[item.itemId];
    if (itemSubstitutionInfo) {
      item.substitutionInfo = itemSubstitutionInfo;
    }
    if (item.isCustom) {
      customItemMap[item.name.toUpperCase()] = index;
    } else {
      medicineProductIdMap[item.productId] = index;
      if (itemSubstitutionInfo) {
        medicineProductIdMap[itemSubstitutionInfo.originalProductDetails.id] = index;
      }
    }
  });

  return {
    productIdIndexMap: {
      medicineProductIdMap,
      otcProductIdMap,
      customItemMap,
    },
    updatedMedicineItems: items,
  };
}
